module.exports = __webpack_public_path__ + "img/blkhl_terraformers.png.609e4c7.png";